import React from 'react';
import {
	SearchDialogProduct,
	PERFORMANCE_IMPROVEMENT_DUMMY_SECTION,
} from '@atlassian/product-search-dialog';

// This component exists to be passed into the search component when it is not expanded with a dummy section
// that is guaranteed to be allowed so that the search component remains interactive and can be expanded. It
// is only used on initial render to prevent unnecessary computation and rendering within the search component.
export default function DummyDialog() {
	return (
		<SearchDialogProduct
			id="jira"
			expandedStateInputPlaceholder="Search"
			sections={[
				{
					id: PERFORMANCE_IMPROVEMENT_DUMMY_SECTION,
					title: 'Jira',
				},
			]}
			// eslint-disable-next-line jira/i18n/text-wrapped-in-format-message
			title="Dummy"
			order={0}
			autocorrectEnabled={false}
			preQueryItemSupplier={() => Promise.resolve({ sections: [] })}
			postQueryItemSupplier={() => Promise.resolve({ sections: [] })}
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			onRetry={() => {}}
		>
			{() => {
				return {
					Footer: () => <></>,
				};
			}}
		</SearchDialogProduct>
	);
}
